module.exports = __webpack_public_path__ + "img/g6.bc6ff9f9.png";